import template from "./template.html";
import {get} from 'lodash';
import {MENU_IDS} from '../../options/constants';

export default {
    name: "globalHeader",
    template: template,
    computed: {
        headerNav() {
            return this.$store.getters.getMenuByID(get(MENU_IDS, 'primary', null));
        },
        headerData() {
            return this.$store.getters.getAcfOptionField('header');
        },
        state() {
            return this.$store.getters.getMainNavState();
        },
    },
    methods: {
        toggle () {
            this.$store.commit('setMainNavState', !this.state);
        },
        hide() {
            this.$store.commit('setMainNavState', false);
        },
        show() {
            this.$store.commit('setMainNavState', true);
        }
    }
};